import { formatDate } from '../../../../../../common/global/helpers';
import {
  OrderItemModel,
  TransactionItemModel,
} from '../../../../models/Orders';

export enum OrdersAndTransactionsTabs {
  Orders = 'orders',
  Transactions = 'transactions',
}

export const formatOrders = (data: OrderItemModel[]): OrderItemModel[] =>
  data.map(e => ({
    ...e,
    dateAdded: formatDate(e.dateAdded),
  }));

export const formatTransactions = (
  data: TransactionItemModel[],
): TransactionItemModel[] =>
  data.map(e => ({
    ...e,
    dateAdded: formatDate(e.dateAdded),
  }));
